var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-image"},[_c('img',{attrs:{"src":_vm.serverUrl + _vm.avatarImage,"alt":"avatar"},on:{"error":function($event){return _vm.avatarImageError()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }